/* Created by Interactive 63 - https://interactive63.com */
/**
 * Helpers for editing inline `style` attribute text.
 */

/** Splits a style attribute into declarations, ignoring semicolons inside quotes or brackets. */
function splitDeclarations(style: string): string[] {
  const parts: string[] = [];
  let depth = 0;
  let quote = '';
  let current = '';
  for (const char of style) {
    if (quote) {
      if (char === quote) quote = '';
    } else if (char === '"' || char === "'") {
      quote = char;
    } else if (char === '(') {
      depth += 1;
    } else if (char === ')') {
      depth = Math.max(0, depth - 1);
    } else if (char === ';' && depth === 0) {
      parts.push(current);
      current = '';
      continue;
    }
    current += char;
  }
  parts.push(current);
  return parts.map((part) => part.trim()).filter((part) => part !== '');
}

/** Returns the value of one property in a style attribute, if declared. */
export function readStyleProperty(style: string, property: string): string | undefined {
  for (const declaration of splitDeclarations(style)) {
    const colon = declaration.indexOf(':');
    if (colon !== -1 && declaration.slice(0, colon).trim().toLowerCase() === property) {
      return declaration.slice(colon + 1).trim();
    }
  }
  return undefined;
}

/** Removes the named properties from a style attribute, returning the remaining text. */
export function removeStyleProperties(style: string, properties: readonly string[]): string {
  const remove = new Set(properties);
  return splitDeclarations(style)
    .filter((declaration) => {
      const colon = declaration.indexOf(':');
      return colon === -1 || !remove.has(declaration.slice(0, colon).trim().toLowerCase());
    })
    .join('; ');
}
